import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _53fa6b48 = () => interopDefault(import('../pages/apps.vue' /* webpackChunkName: "pages/apps" */))
const _a36ef0fe = () => interopDefault(import('../pages/appsmanager.vue' /* webpackChunkName: "pages/appsmanager" */))
const _0550ad78 = () => interopDefault(import('../pages/appsmanager/index.vue' /* webpackChunkName: "pages/appsmanager/index" */))
const _5d9c525c = () => interopDefault(import('../pages/appsmanager/groups.vue' /* webpackChunkName: "pages/appsmanager/groups" */))
const _663d0192 = () => interopDefault(import('../pages/appsmanager/new.vue' /* webpackChunkName: "pages/appsmanager/new" */))
const _52872cac = () => interopDefault(import('../pages/appsmanager/_id.vue' /* webpackChunkName: "pages/appsmanager/_id" */))
const _23c95757 = () => interopDefault(import('../pages/confirmaccount.vue' /* webpackChunkName: "pages/confirmaccount" */))
const _21638628 = () => interopDefault(import('../pages/forgotpassword.vue' /* webpackChunkName: "pages/forgotpassword" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _49c57cf4 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _d5f21fa2 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _47876c70 = () => interopDefault(import('../pages/resetpassword.vue' /* webpackChunkName: "pages/resetpassword" */))
const _7364f08e = () => interopDefault(import('../pages/users.vue' /* webpackChunkName: "pages/users" */))
const _c91b56de = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _9ce75da2 = () => interopDefault(import('../pages/users/list.vue' /* webpackChunkName: "pages/users/list" */))
const _05b41c1f = () => interopDefault(import('../pages/users/new.vue' /* webpackChunkName: "pages/users/new" */))
const _705aff43 = () => interopDefault(import('../pages/users/pending-invitations.vue' /* webpackChunkName: "pages/users/pending-invitations" */))
const _88c5ebe4 = () => interopDefault(import('../pages/users/request.vue' /* webpackChunkName: "pages/users/request" */))
const _6edd63de = () => interopDefault(import('../pages/users/request/index.vue' /* webpackChunkName: "pages/users/request/index" */))
const _74e4be8e = () => interopDefault(import('../pages/users/request/_id.vue' /* webpackChunkName: "pages/users/request/_id" */))
const _3eb26608 = () => interopDefault(import('../pages/users/roles.vue' /* webpackChunkName: "pages/users/roles" */))
const _e6602498 = () => interopDefault(import('../pages/users/settings.vue' /* webpackChunkName: "pages/users/settings" */))
const _3fcf4592 = () => interopDefault(import('../pages/users/settings/index.vue' /* webpackChunkName: "pages/users/settings/index" */))
const _7f5fd881 = () => interopDefault(import('../pages/users/settings/authflow.vue' /* webpackChunkName: "pages/users/settings/authflow" */))
const _48aff642 = () => interopDefault(import('../pages/users/settings/emails.vue' /* webpackChunkName: "pages/users/settings/emails" */))
const _4687a13f = () => interopDefault(import('../pages/users/settings/groups.vue' /* webpackChunkName: "pages/users/settings/groups" */))
const _48cbfc1d = () => interopDefault(import('../pages/users/settings/passwords.vue' /* webpackChunkName: "pages/users/settings/passwords" */))
const _254cd5a2 = () => interopDefault(import('../pages/users/settings/roles.vue' /* webpackChunkName: "pages/users/settings/roles" */))
const _cb1a2a5c = () => interopDefault(import('../pages/users/upload.vue' /* webpackChunkName: "pages/users/upload" */))
const _51521a10 = () => interopDefault(import('../pages/users/groups/list.vue' /* webpackChunkName: "pages/users/groups/list" */))
const _bbc8ada2 = () => interopDefault(import('../pages/users/groups/members.vue' /* webpackChunkName: "pages/users/groups/members" */))
const _86ccc594 = () => interopDefault(import('../pages/users/groups/new.vue' /* webpackChunkName: "pages/users/groups/new" */))
const _74306453 = () => interopDefault(import('../pages/users/groups/roles.vue' /* webpackChunkName: "pages/users/groups/roles" */))
const _1c03718e = () => interopDefault(import('../pages/users/_id.vue' /* webpackChunkName: "pages/users/_id" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apps",
    component: _53fa6b48,
    name: "apps"
  }, {
    path: "/appsmanager",
    component: _a36ef0fe,
    children: [{
      path: "",
      component: _0550ad78,
      name: "appsmanager"
    }, {
      path: "groups",
      component: _5d9c525c,
      name: "appsmanager-groups"
    }, {
      path: "new",
      component: _663d0192,
      name: "appsmanager-new"
    }, {
      path: ":id",
      component: _52872cac,
      name: "appsmanager-id"
    }]
  }, {
    path: "/confirmaccount",
    component: _23c95757,
    name: "confirmaccount"
  }, {
    path: "/forgotpassword",
    component: _21638628,
    name: "forgotpassword"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/logout",
    component: _49c57cf4,
    name: "logout"
  }, {
    path: "/profile",
    component: _d5f21fa2,
    name: "profile"
  }, {
    path: "/resetpassword",
    component: _47876c70,
    name: "resetpassword"
  }, {
    path: "/users",
    component: _7364f08e,
    children: [{
      path: "",
      component: _c91b56de,
      name: "users"
    }, {
      path: "list",
      component: _9ce75da2,
      name: "users-list"
    }, {
      path: "new",
      component: _05b41c1f,
      name: "users-new"
    }, {
      path: "pending-invitations",
      component: _705aff43,
      name: "users-pending-invitations"
    }, {
      path: "request",
      component: _88c5ebe4,
      children: [{
        path: "",
        component: _6edd63de,
        name: "users-request"
      }, {
        path: ":id",
        component: _74e4be8e,
        name: "users-request-id"
      }]
    }, {
      path: "roles",
      component: _3eb26608,
      name: "users-roles"
    }, {
      path: "settings",
      component: _e6602498,
      children: [{
        path: "",
        component: _3fcf4592,
        name: "users-settings"
      }, {
        path: "authflow",
        component: _7f5fd881,
        name: "users-settings-authflow"
      }, {
        path: "emails",
        component: _48aff642,
        name: "users-settings-emails"
      }, {
        path: "groups",
        component: _4687a13f,
        name: "users-settings-groups"
      }, {
        path: "passwords",
        component: _48cbfc1d,
        name: "users-settings-passwords"
      }, {
        path: "roles",
        component: _254cd5a2,
        name: "users-settings-roles"
      }]
    }, {
      path: "upload",
      component: _cb1a2a5c,
      name: "users-upload"
    }, {
      path: "groups/list",
      component: _51521a10,
      name: "users-groups-list"
    }, {
      path: "groups/members",
      component: _bbc8ada2,
      name: "users-groups-members"
    }, {
      path: "groups/new",
      component: _86ccc594,
      name: "users-groups-new"
    }, {
      path: "groups/roles",
      component: _74306453,
      name: "users-groups-roles"
    }, {
      path: ":id",
      component: _1c03718e,
      name: "users-id"
    }]
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
